// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2dyxO","bigColWidth":"Table_bigColWidth__2WAO4","biggerColWidth":"Table_biggerColWidth__1FXoi","row":"Table_row__2zvnY","col":"Table_col__1SkNZ"};